// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"style_cardContainer__-lPkc","cardContainerList":"style_cardContainerList__1MroY","marginVertical":"style_marginVertical__AEhaB"};